<template>
    <paper class="appointment">
        <el-tabs v-model="activeName" @tab-click="tabClick">
            <el-tab-pane label="在途跟踪" name="Tracking">
                <Tracking/>
            </el-tab-pane>
            <el-tab-pane label="在途时效预警" name="Warning">
                <Warning/>
            </el-tab-pane>
            <el-tab-pane label="在途跟踪可视化" name="Visualization">
                <Visualization/>
            </el-tab-pane>
        </el-tabs>
    </paper>
</template>
<script>
import paper from '@/components/core/paper/Paper';
import Tracking from './tracking/Index';
import Warning from './warning/Index';
import Visualization from './visualization/Index';
export default {
    name: 'passage',
    components: { paper, Tracking, Warning, Visualization },
    data() {
        return {
            activeName: 'Tracking'
        };
    },
    methods: {
        tabClick(val) {
            const btnVal = {
                Tracking: '订单管理-大物流,在途管理,在途跟踪,在途跟踪-查询',
                Warning: '订单管理-大物流,在途管理,在途时效预警,在途时效预警-查询',
                Visualization: '订单管理-大物流,在途管理,在途跟踪可视化,在途跟踪可视化-搜索'
            };
            window.bigDataConfig = { 'bigData-btn-search': btnVal[val.name] };
        }
    },
    activated () {
        this.tabClick({ name: this.activeName });
    }
};
</script>
<style lang="less">
.appointment{
    .tablePage{
        .el-table {
            min-height: calc(~ '100vh - 223px') !important;
            max-height: calc(~ '100vh - 223px') !important;
        }
    }
}
</style>